import { useGet } from "@ngt/forms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";
import { StagePricelistGetByStageIdSubStage, StagePricelistGetByStageIdSubStageResponse, SubStages } from "../../api/dtos";


const getData = (response?: SWRResponse<StagePricelistGetByStageIdSubStageResponse,StagePricelistGetByStageIdSubStageResponse> ) => {
    return response?.data?.data
} 

const getError = (response?: SWRResponse<StagePricelistGetByStageIdSubStageResponse,StagePricelistGetByStageIdSubStageResponse> ) => {
    return (response?.error ?? response?.data)?.responseStatus
} 

const useStagePricelistByStageIdSubStage = (stageId?: number | null, subStage?: SubStages | null, configuration?: SWRConfiguration<StagePricelistGetByStageIdSubStageResponse, StagePricelistGetByStageIdSubStageResponse>) => {
    
    const request = useMemo(() => {
        return stageId ? () => {
            return new StagePricelistGetByStageIdSubStage({
                stageId: stageId,
                subStage: subStage ?? undefined
            });
        } : undefined;
    },[stageId, subStage])

    return useGet(request, {getData, getError}, configuration);
}

export default useStagePricelistByStageIdSubStage